/* Conversion Dude - Subscription landing page (cd-sw-* sections) */
(function () {
  if (window.__cdslLoaded) return;
  window.__cdslLoaded = true;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return (cents / 100).toFixed(2);
    function fmt(num, decimals, thousands, dec) {
      decimals = decimals == null ? 2 : decimals;
      thousands = thousands || ',';
      dec = dec || '.';
      if (isNaN(num) || num == null) return '0';
      num = (num / 100).toFixed(decimals);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? dec + parts[1] : '');
    }
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'"); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(match[0], value);
  }

  /* ---------------- Gallery ---------------- */
  function initGallery(root) {
    var track = root.querySelector('[data-track]');
    if (!track || track.dataset.ready) return;
    track.dataset.ready = '1';
    var slides = track.children;
    var thumbs = root.querySelectorAll('[data-thumbs] button');
    var count = root.querySelector('[data-count]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var current = 0;

    if (slides.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      var th = root.querySelector('[data-thumbs]');
      if (th) th.hidden = true;
    }

    function go(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      current = i;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      if (i !== current) mark(i);
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.dataset.index, 10)); });
    });
    mark(0);
    root.cdslGoToMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].dataset.mediaId) === String(mediaId)) { go(i); return; }
      }
    };
  }

  /* ---------------- Buy box ---------------- */
  function initBuybox(box) {
    if (box.dataset.ready) return;
    var dataEl = box.querySelector('[data-cdsl-product]');
    var gallery = box.querySelector('[data-cdsl-gallery]');
    if (gallery) initGallery(gallery);
    if (!dataEl) return;
    box.dataset.ready = '1';

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { console.error('cdsl: bad product json', e); return; }

    var optionInputs = box.querySelectorAll('input[data-option-index]');
    var variantInputs = box.querySelectorAll('[data-variant-input]');
    var planSelect = box.querySelector('[data-plan-select]');
    var planInput = box.querySelector('[data-plan-input]');
    var priceNow = box.querySelector('[data-price-now]');
    var priceWas = box.querySelector('[data-price-was]');
    var mainBtn = box.querySelector('[data-main-submit]');
    var mainLabel = mainBtn ? mainBtn.querySelector('span').textContent : '';
    var otBtn = box.querySelector('[data-ot-submit]');
    var otPrice = box.querySelector('[data-ot-price]');
    var otSub = box.querySelector('[data-ot-sub]');
    var variant = null;

    function selectedOptions() {
      var opts = [];
      optionInputs.forEach(function (i) { if (i.checked) opts[parseInt(i.dataset.optionIndex, 10)] = i.value; });
      return opts;
    }

    function findVariant() {
      if (data.variants.length === 1) return data.variants[0];
      var opts = selectedOptions();
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
      }) || null;
    }

    function markUnavailable() {
      var opts = selectedOptions();
      optionInputs.forEach(function (input) {
        var idx = parseInt(input.dataset.optionIndex, 10);
        var possible = data.variants.some(function (v) {
          if (!v.available || v.options[idx] !== input.value) return false;
          return v.options.every(function (o, i) { return i === idx || opts[i] === undefined || opts[i] === o; });
        });
        input.parentElement.classList.toggle('is-unavailable', !possible);
      });
    }

    function buildPlans() {
      if (!planSelect || !variant) return;
      var previous = planSelect.value;
      planSelect.innerHTML = '';
      var allowed = variant.alloc.map(function (a) { return a.plan; });
      data.plans.forEach(function (p) {
        if (allowed.indexOf(p.id) === -1) return;
        var o = document.createElement('option');
        o.value = p.id;
        o.textContent = p.name;
        planSelect.appendChild(o);
      });
      var wrap = box.querySelector('[data-plan-wrap]');
      if (wrap) wrap.hidden = planSelect.options.length < 2;
      if (previous && planSelect.querySelector('option[value="' + previous + '"]')) {
        planSelect.value = previous;
      } else if (data.defaultPlan) {
        for (var i = 0; i < planSelect.options.length; i++) {
          if (planSelect.options[i].textContent.toLowerCase().indexOf(data.defaultPlan) !== -1) { planSelect.selectedIndex = i; break; }
        }
      }
    }

    function render() {
      variant = findVariant();
      markUnavailable();
      if (!variant) {
        if (mainBtn) { mainBtn.setAttribute('aria-disabled', 'true'); mainBtn.querySelector('span').textContent = data.soldOut; }
        return;
      }
      variantInputs.forEach(function (i) { i.value = variant.id; });
      buildPlans();

      var now = variant.price;
      var was = variant.compare > variant.price ? variant.compare : 0;
      if (data.hasPlans && planSelect) {
        var planId = parseInt(planSelect.value, 10);
        var alloc = variant.alloc.find(function (a) { return a.plan === planId; }) || variant.alloc[0];
        if (alloc) {
          now = alloc.price;
          var base = Math.max(variant.price, variant.compare || 0, alloc.compare || 0);
          was = base > alloc.price ? base : 0;
          if (planInput) planInput.value = alloc.plan;
        }
      }
      if (priceNow) priceNow.textContent = formatMoney(now, data.moneyFormat);
      if (priceWas) priceWas.textContent = data.saveText ? '' : (was ? formatMoney(was, data.moneyFormat) : '');
      if (priceWas && data.saveText) { priceWas.textContent = data.saveText; priceWas.style.textDecoration = 'none'; priceWas.style.opacity = '1'; }

      if (mainBtn) {
        mainBtn.querySelector('span').textContent = variant.available ? mainLabel : data.soldOut;
        if (variant.available) mainBtn.removeAttribute('aria-disabled'); else mainBtn.setAttribute('aria-disabled', 'true');
      }

      if (otPrice) otPrice.textContent = formatMoney(variant.price, data.moneyFormat);
      if (otBtn) { if (variant.available) otBtn.removeAttribute('aria-disabled'); else otBtn.setAttribute('aria-disabled', 'true'); }
      if (otSub) {
        if (variant.compare > variant.price && data.otSaveText) {
          var pct = Math.round((1 - variant.price / variant.compare) * 100);
          otSub.innerHTML = '<s>' + formatMoney(variant.compare, data.moneyFormat) + '</s> &middot; ' + data.otSaveText.replace('[percent]', pct);
          otSub.hidden = false;
        } else {
          otSub.hidden = true;
        }
      }

      if (variant.media && gallery && gallery.cdslGoToMedia) gallery.cdslGoToMedia(variant.media);

      var subtitle = variant.title === 'Default Title' ? '' : variant.title;
      document.dispatchEvent(new CustomEvent('cdsl:variant', { detail: { title: subtitle, image: variant.image, available: variant.available } }));
    }

    optionInputs.forEach(function (i) { i.addEventListener('change', render); });
    if (planSelect) planSelect.addEventListener('change', render);
    render();

    if (data.discountCode && !window.Shopify?.designMode && !sessionStorage.getItem('cdsl-code-' + data.discountCode)) {
      fetch('/discount/' + encodeURIComponent(data.discountCode) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
        .then(function () { try { sessionStorage.setItem('cdsl-code-' + data.discountCode, '1'); } catch (e) {} })
        .catch(function () {});
    }
  }

  /* ---------------- Sticky bars ---------------- */
  function initSticky(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var bars = el.querySelectorAll('.cdsl-sticky');
    var buttons = el.querySelectorAll('[data-sticky-cta]');
    var action = el.dataset.action;

    document.addEventListener('cdsl:variant', function (e) {
      var t = el.querySelector('[data-sticky-variant]');
      var img = el.querySelector('[data-sticky-img]');
      if (t) t.textContent = e.detail.title;
      if (img && e.detail.image) img.src = e.detail.image;
    });

    buttons.forEach(function (b) {
      b.addEventListener('click', function (e) {
        var box = document.querySelector('[data-cdsl-buybox]');
        if (!box) return;
        e.preventDefault();
        var submit = box.querySelector('[data-main-submit]');
        if (action === 'add' && submit && submit.getAttribute('aria-disabled') !== 'true') {
          submit.click();
        } else {
          box.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    var showAfter = document.querySelector(el.dataset.showAfter || '[data-cdsl-buybox] [data-main-submit]');
    function setVisible(v) { bars.forEach(function (b) { b.classList.toggle('is-visible', v); b.setAttribute('aria-hidden', v ? 'false' : 'true'); }); }
    if (window.Shopify && window.Shopify.designMode && el.dataset.alwaysEditor === 'true') { setVisible(true); return; }
    var ticking = false;
    function check() {
      ticking = false;
      if (showAfter) setVisible(showAfter.getBoundingClientRect().bottom < 0);
      else setVisible(window.scrollY > 700);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  function initAll() {
    document.querySelectorAll('[data-cdsl-buybox]').forEach(initBuybox);
    document.querySelectorAll('[data-cdsl-sticky]').forEach(initSticky);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-cdsl-buybox], [data-cdsl-sticky]').forEach(function (n) { delete n.dataset.ready; });
    document.querySelectorAll('[data-track]').forEach(function (n) { delete n.dataset.ready; });
    initAll();
  });
})();
